import React, { useState, useContext } from 'react';
import ButtonPrimary from '../../components/buttons/ButtonPrimary';
import { useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import AuthContext from '../../contexts/AuthContext';
import AuthService from '../../services/AuthService';

const RegistrationForm = ({ onToggleLogin }) => {
    const navigate = useNavigate();
    const [showRegister, setShowRegister] = useState(true);
    const [username, setUsername] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState(''); 

    const auth = useContext(AuthContext);

    const emptyField = () => {
        setPassword("");
        setEmail("");
        setUsername("");
    }

    const handleRegisterSubmit = async (event) => {
        event.preventDefault();

        try {
            const response = await fetch('/api/auth/register', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email, username, password })
            });

            const data = await response.json();

            if (response.status === 200) {
                // Login was successful, set user session and redirect to the /home route
                AuthService.setUserSession(data.user);
                auth.setUser(data.user);

                navigate('/home');
            } else {
                // An error occurred, show error message
                toast.error(data.message || 'An error occurred');
                emptyField();
            }
        } catch (error) {
            // Handle errors during the request (e.g., network error)
            toast.error(error.message || 'An error occurred');
            emptyField();
        }
    };

    //const handleRegisterSubmit = (event) => {
    //    event.preventDefault();
    //    // Handle form submission logic here
    //};

    const handleGoogleSignup = () => {
        // Redirect to Google OAuth signup
        window.open('/api/auth/google', '_self');
    };

    const handleFacebookSignup = () => {
        // Redirect to Facebook OAuth signup
        window.open('/api/auth/facebook', '_self');
    };


    const handleUsernameChange = (event) => {
        setUsername(event.target.value);
    };

    const handleEmailChange = (event) => {
        setEmail(event.target.value);
    };

    const handlePasswordChange = (event) => {
        setPassword(event.target.value);
    };

    const handleToggleLogin = () => {
        onToggleLogin();
    };

    return (
        <>
            <form
                id="signup-form"
                className={showRegister ? 'show' : 'hide'}
                onSubmit={handleRegisterSubmit}
            >
                <div className="row">
                    <div className="col-12">
                        <span id="signup-title">Registration</span>
                    </div>
                </div>
                <div className="row margin-btm-30">
                    <div className="col-12">
                        <span className="icon">
                            <ion-icon name="username"></ion-icon>
                        </span>
                        <input
                            className="form-control fillet-text-box"
                            type="text"
                            placeholder="Username"
                            name="username"
                            value={username}
                            onChange={handleUsernameChange}
                            required
                        />
                    </div>
                </div>
                <div className="row margin-btm-30">
                    <div className="col-12">
                        <span className="icon">
                            <ion-icon name="mail"></ion-icon>
                        </span>
                        <input
                            className="form-control fillet-text-box"
                            type="text"
                            placeholder="Email"
                            name="email"
                            value={email}
                            onChange={handleEmailChange}
                            required
                        />
                    </div>
                </div>
                <div className="row margin-btm-15">
                    <div className="col-12">
                        <span className="icon">
                            <ion-icon name="loc-closed"></ion-icon>
                        </span>
                        <input
                            className="form-control fillet-text-box"
                            type="password"
                            placeholder="Password"
                            name="password"
                            value={password}
                            onChange={handlePasswordChange}
                            required
                        />
                    </div>
                </div>
                <div className="row margin-btm-15">
                    <div className="col-12 align-left">
                        <label>
                            <input type="checkbox" required />
                            I agree to the <a href="/terms" target="_blank"><u>terms & conditions</u></a>
                        </label>
                    </div>
                </div>

                <ButtonPrimary className="margin-btm-15" type="submit" value="Register" />

                <div className="row margin-btm-15">
                    <div className="col-12">
                        <span>
                            Already have an account?{' '}
                            <a className="bold login-toggle-btn" onClick={handleToggleLogin}>
                                Login
                            </a>
                        </span>
                    </div>
                </div>

                {/*<div className="row margin-btm-15">*/}
                {/*    <div className="col-12">*/}
                {/*        <span className="back-line">or</span>*/}
                {/*    </div>*/}
                {/*</div>*/}

                {/*<div className="row">*/}
                {/*    <div className="col-6">*/}
                {/*        <ButtonPrimary type="submit" value="Facebook" onClick={handleFacebookSignup} />*/}
                {/*    </div>*/}
                {/*    <div className="col-6">*/}
                {/*        <ButtonPrimary type="submit" value="Google" onClick={handleGoogleSignup} />*/}
                {/*    </div>*/}
                {/*</div>*/}
            </form>
        </>
    );
};

export default RegistrationForm;
